<template>
  <label
    class="
      bg-white
      border
      rounded-md
      py-3
      px-3
      flex
      items-center
      justify-center
      text-lg
      font-bold
      uppercase
      sm:flex-1
      cursor-pointer
      focus:outline-none
    "
    :class="{
      'bg-teal-200 border-transparent text-white  text-teal-700':
        checked,
    }"
    @click="checked = !checked"
  >
    <input
     @click="checked = !checked"
      type="radio"
      name="memory-option"
      value="4 GB"
      class="sr-only"
      aria-labelledby="memory-option-0-label"
    />
         <div class="flex space-x-2 space-x-reverse">
          <!-- Heroicon name: check -->
          <svg
            v-if="checked"
            class="flex-shrink-0 h-6 w-6 text-teal-700"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <div class="space-y-2">
            <dt class="text-lg leading-6 font-medium text-gray-900">
       {{ name }}
            </dt>
          </div>
        </div>
  </label>
</template>

<script>
export default {
  props: ["name"],
  data() {
    return {
      checked: false,
    };
  },
};
</script>